module.exports = __webpack_public_path__ + "img/TS6301-310.72e4e6bc.jpg";